<script setup>
import { useNotification } from "@kyvg/vue3-notification";
import { useAlertStore } from "../../stores/alert.store";
const { notify } = useNotification();

const store = useAlertStore();
if (store.alert) {
  notify({
    title: "Authorization",
    text: "You have been logged in!",
  });
}
</script>
